import classNames from 'classnames'
import * as React from 'react'

import {makeEditable} from '@/common/utils'
import DynamicIcon from '@/components/DynamicIcon'
import {Grid} from '@/components/Grid'
import Image from '@/components/Image'
import Link from '@/components/Link'

const Team = ({backgroundColors, members, _editable}) => {
  return (
    <section {...makeEditable(_editable)} className={classNames('py-12', backgroundColors.current)}>
      <Grid>
        <ul className='col-span-full flex w-full flex-col gap-y-6 lg:mx-auto lg:grid lg:max-w-screen-xl lg:grid-cols-12 lg:gap-x-4'>
          {members.map((member) => {
            return (
              <li
                key={member.uuid}
                className='flex flex-col justify-between rounded-2xl bg-yellow-200 py-6 px-4 md:flex-row lg:col-span-6 lg:flex-1'
              >
                <div className='flex flex-row items-center gap-x-6'>
                  <div className='inline-block h-[84px] w-[84px] overflow-hidden rounded-full'>
                    <Image
                      {...member.content.image}
                      fitIn={true}
                      ratio='1:1'
                      className='rounded-2xl'
                    />
                  </div>
                  <div className='inline-block'>
                    <div className='body-xl-bold'>{member.content.name}</div>
                    <div className='body-m-medium'>
                      {member.content.company}
                      {member.content.job && <span> - {member.content.job}</span>}
                    </div>
                  </div>
                </div>
                <div className='flex items-center pl-27 pt-5 md:p-0'>
                  <Link
                    link={member.content.linkedin}
                    className='flex items-center rounded-2xl bg-yellow-300 p-4'
                    target={member.content.linkedin}
                    rel={member.content.linkedin === '_blank' ? 'noopener noreferrer' : undefined}
                  >
                    <DynamicIcon aria-hidden icon={'IconLinkedin'} />
                  </Link>
                </div>
              </li>
            )
          })}
        </ul>
      </Grid>
    </section>
  )
}

export default Team
